module.exports = __webpack_public_path__ + "img/task-thumbs.5c9462a0.png";